import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';

const SizeSoftXLectorCodigoBarrasConteos = forwardRef(function SizeSoftXLectorCodigoBarrasConteos(props, ref) {
  const { disabled, onColectorScan } = props;

  const inputRef = useRef(null);

  const [barcode, setBarcode] = useState("");
  const barcodeRef = useRef("");

  const setBarcodeValue = (value) => {
    barcodeRef.current = value;
    setBarcode(value);
  };

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
      inputRef.current?.click?.();
      inputRef.current?.select?.();
    },
    clear: () => setBarcodeValue(''),
    getValue: () => barcode,
  }), [barcode]);

  useEffect(() => {
    const focusBarcode = () => {
      const el = inputRef.current;
      if (!el) return;

      if (document.activeElement === el) return;

      el.focus();
      el.click?.();
      el.select?.();
    };

    focusBarcode();

    const shouldIgnoreTarget = (target) => {
      if (!target) return false;
      const interactive = target.closest?.(
        'input, textarea, select, button, [contenteditable="true"], [role="option"], [role="listbox"], [role="dialog"], [role="button"], .MuiAutocomplete-popper'
      );
      return Boolean(interactive) && target.id !== "txtCodigoBarrasConteos";
    };

    const onAnyPointer = (e) => {
      if (shouldIgnoreTarget(e.target)) return;
      requestAnimationFrame(() => focusBarcode());
    };

    document.addEventListener("pointerdown", onAnyPointer, true);
    document.addEventListener("mousedown", onAnyPointer, true);
    document.addEventListener("touchstart", onAnyPointer, true);
    window.addEventListener("focus", focusBarcode);

    return () => {
      document.removeEventListener("pointerdown", onAnyPointer, true);
      document.removeEventListener("mousedown", onAnyPointer, true);
      document.removeEventListener("touchstart", onAnyPointer, true);
      window.removeEventListener("focus", focusBarcode);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();

      const codigo = barcodeRef.current;

      if (!codigo) {
        setBarcodeValue('');
        return;
      }

      if (onColectorScan) {
        onColectorScan(codigo);
      }
      setBarcodeValue('');
      return;
    }

    // NOTA: Alt+F1 es atajo global del módulo (abrir buscador / enfocar
    // filtro). No interceptarlo aquí: el handler global en capture ya lo
    // gestionó; si llegara hasta este input, dejarlo fluir.

    if (event.key === 'Delete' || event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      setBarcodeValue('');
      return;
    }

    if (event.key === 'Backspace') {
      event.preventDefault();
      event.stopPropagation();
      if (!barcodeRef.current) return;
      const codex = barcodeRef.current.slice(0, -1);
      setBarcodeValue(codex);
      return;
    }

    const invalidKeys = [
      'ArrowUp','ArrowDown','ArrowRight','ArrowLeft','Insert','Home','End',
      'PageDown','PageUp','ContextMenu','AltGraph','Meta','Tab',
      'Alt','Control','Shift','CapsLock','NumLock','ScrollLock','Pause',
      'F1','F2','F3','F4','F5','F6','F7','F8','F9','F10','F11'
    ];

    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.ctrlKey || event.altKey || event.metaKey || (event.key || '').length !== 1) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    setBarcodeValue(barcodeRef.current + event.key);
  };

  return (
    <div className="framedetallesventa">
      <h2 className="framedetallesventaLabel">Lector c&oacute;digos</h2>

      <input
        id="txtCodigoBarrasConteos"
        className="txtCodigoBarras"
        ref={inputRef}
        type="text"
        inputMode="text"
        enterKeyHint="enter"
        autoComplete="off"
        name="lector-codigo-barras"
        aria-autocomplete="none"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        data-lpignore="true"
        data-1p-ignore="true"
        value={barcode}
        onChange={() => {}}
        onKeyDown={handleKeyDown}
        placeholder="Escanear los c&oacute;digos de barras aqu&iacute;"
        disabled={disabled}
      />
    </div>
  );
});

export default SizeSoftXLectorCodigoBarrasConteos;
